import { StatusPanelDef } from 'ag-grid-community'
import { useMemo } from 'react'

export const useStatusBar = () => {
  return useMemo<{ statusPanels: StatusPanelDef[] }>(() => {
    return {
      statusPanels: [{ statusPanel: 'agAggregationComponent' }],
    }
  }, [])
}
